export class helperFunctions {
  static checkCodiceFiscale(
    cognome: string,
    nome: string,
    data_nascita: Date,
    sesso: string,
    comune_nascita: string,
    CF: string,
    fullCheck = true
  ): any {
    let giorno_inserito: number;
    let mese_inserito: number;
    let anno_inserito: number;

    //messaggi di errore personalizzati
    const mCogn = "Il cognome non corrisponde al CF !!";
    const mNome = "Il nome non corrisponde al CF !!";
    const mGior = "Il giorno/sesso non corrisponde al CF !!";
    const mMese = "Il mese non corrisponde al CF !!";
    const mAnno = "L'anno non corrisponde al CF !!";
    const mLuog = "Il luogo non corrisponde al CF !!";
    const mGene = "I dati inseriti non corrispondono al CF !!";
    const mData = "La data inserita non è stata riconosciuta correttamente !!";
    const mDat1 =
      "La data inserita è successiva al giorno corrente del sistema [" +
      new Date().toLocaleDateString() +
      "] !!";

    //costanti calcolo CF
    const MONTH_CODES = [
      "A", //1
      "B", //2
      "C", //3
      "D", //4
      "E", //5
      "H", //6
      "L", //7
      "M", //8
      "P", //9
      "R", //10
      "S", //11
      "T", //12
    ];

    const OMOCODIA_TABLE = {
      0: "L",
      1: "M",
      2: "N",
      3: "P",
      4: "Q",
      5: "R",
      6: "S",
      7: "T",
      8: "U",
      9: "V",
    };

    const CHECK_CODE_ODD = {
      0: 1,
      1: 0,
      2: 5,
      3: 7,
      4: 9,
      5: 13,
      6: 15,
      7: 17,
      8: 19,
      9: 21,
      A: 1,
      B: 0,
      C: 5,
      D: 7,
      E: 9,
      F: 13,
      G: 15,
      H: 17,
      I: 19,
      J: 21,
      K: 2,
      L: 4,
      M: 18,
      N: 20,
      O: 11,
      P: 3,
      Q: 6,
      R: 8,
      S: 12,
      T: 14,
      U: 16,
      V: 10,
      W: 22,
      X: 25,
      Y: 24,
      Z: 23,
    };

    const CHECK_CODE_EVEN = {
      0: 0,
      1: 1,
      2: 2,
      3: 3,
      4: 4,
      5: 5,
      6: 6,
      7: 7,
      8: 8,
      9: 9,
      A: 0,
      B: 1,
      C: 2,
      D: 3,
      E: 4,
      F: 5,
      G: 6,
      H: 7,
      I: 8,
      J: 9,
      K: 10,
      L: 11,
      M: 12,
      N: 13,
      O: 14,
      P: 15,
      Q: 16,
      R: 17,
      S: 18,
      T: 19,
      U: 20,
      V: 21,
      W: 22,
      X: 23,
      Y: 24,
      Z: 25,
    };

    const CHECK_CODE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    /***
     *  parte di configurazione della funzione
     ***/
    const debug = false; //visualizza messaggi di info in caso di errore
    //fine campi configurazione funzione
    //workaroud prima versione implementata nel 978 togliere a regime

    if (!data_nascita && CF) {
      const anno = parseInt(CF.substr(6, 2), 10);
      let temp = parseInt(CF.substr(9, 2), 10);
      let date = (anno < 20 ? '20' + anno : '19' + anno)+"-"+MONTH_CODES.indexOf(CF.substr(8, 1))+"-"+((temp > 40) ? temp-40 : temp);
      data_nascita = new Date(date);
    }

    if (!cognome || !nome || (fullCheck && !data_nascita) || !sesso || (fullCheck && !comune_nascita) || !CF)
      return "Compilare tutti i campi richiesti !";
    if (
      cognome &&
      nome &&
      ((fullCheck && data_nascita) || !fullCheck) &&
      sesso &&
      ((fullCheck && comune_nascita) || !fullCheck) &&
      CF &&
      CF.length < 16
    ) {
      return "Inserisci il codice fiscale completo";
    } else {
      try {
        //controlli sulla forma dei dati inseriti
        if (cognome.length < 2) return "Cognome troppo corto !!";
        if (nome.length < 2) return "Nome troppo corto !!";
        if (sesso.length != 1)
          return "Il sesso non è valorizzato correttamente !!";

        if (fullCheck) {
          if (comune_nascita.length < 2)
          return "Il comune di nascita non è valorizzato correttamente !!";

          /* PARTE MOLTO DELICATA in quanto dipendente da come viene rappresentata un a data in myDynamo */
          try {
            //var d = new Date(data_nascita.replace( /(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"));
            var d = new Date(data_nascita);
            if (d > new Date()) return mDat1;
            giorno_inserito = d.getDate(); //ritorna il giorno del mese
            mese_inserito = d.getMonth() + 1; //il mese in JS è un array 0-based
            anno_inserito = d.getFullYear();
          } catch (e) {
            return mData;
          }
        }

        // generazione CF da dati inseriti
        cognome = cognome.toUpperCase().trim();
        nome = nome.toUpperCase().trim();
        sesso = sesso.toUpperCase().trim();
        // comune_nascita = comune_nascita.toUpperCase().trim();
        CF = CF.toUpperCase().trim();

        let CF_calcolato = "";

        let lista_consonanti_cogn = cognome.replace(
          /[^BCDFGHJKLMNPQRSTVWXYZ]/gi,
          ""
        );
        let lista_vocali_cogn = cognome.replace(/[^AEIOU]/gi, "");
        let cod_cogn_calcolato = (
          lista_consonanti_cogn +
          lista_vocali_cogn +
          "XXX"
        )
          .substr(0, 3)
          .toUpperCase();

        let lista_consonanti_nome = nome.replace(
          /[^BCDFGHJKLMNPQRSTVWXYZ]/gi,
          ""
        );

        if (lista_consonanti_nome.length >= 4) {
          lista_consonanti_nome =
            lista_consonanti_nome.substr(0, 1) +
            lista_consonanti_nome.substr(2, lista_consonanti_nome.length - 1);
        }

        let lista_vocali_nome = nome.replace(/[^AEIOU]/gi, "");
        let cod_nome_calcolato = (
          lista_consonanti_nome +
          lista_vocali_nome +
          "XXX"
        )
          .substr(0, 3)
          .toUpperCase();
        let cod_anno_calcolato = (fullCheck) ? anno_inserito
          .toString()
          .substr(
            anno_inserito.toString().length - 2,
            anno_inserito.toString().length - 2
          ) : 'XX';
        let cod_mese_calcolato = (fullCheck) ? MONTH_CODES[mese_inserito - 1] : 'X';

        let cod_giorno_calcolato: any = (fullCheck) ?
          ( sesso === "M" ? giorno_inserito : giorno_inserito + 40 ) : 'XX';
        if (fullCheck && cod_giorno_calcolato > 0 && cod_giorno_calcolato < 10)
          cod_giorno_calcolato = "0" + cod_giorno_calcolato;
        //cod luogo nascita
        let cod_luogo_nascita_calcolato = "_ND_";

        /* 
                     for (let i = 0; i < COMUNI.length; i++) {
                          if (COMUNI[i][2] === comune_nascita)
                              cod_luogo_nascita_calcolato = COMUNI[i][0];
                      };
                      */
        cod_luogo_nascita_calcolato = (fullCheck) ? comune_nascita : 'XX';
        CF_calcolato =
          cod_cogn_calcolato +
          cod_nome_calcolato +
          cod_anno_calcolato +
          cod_mese_calcolato +
          cod_giorno_calcolato +
          cod_luogo_nascita_calcolato;

        let famigliaCF = new Array();

        let posizione_caratteri_sostituibili = [14, 13, 12, 10, 9, 7, 6];

        let ocodies = posizione_caratteri_sostituibili.length;

        for (let o = 0; o <= ocodies; o++) {
          if (o != 0) {
            //passaggi successivi al primo => mi calcolo CF in omocodia
            let i = o - 1;
            let valore_da_sostituire =
              CF_calcolato[posizione_caratteri_sostituibili[i]];
            CF_calcolato =
              CF_calcolato.substring(0, posizione_caratteri_sostituibili[i]) +
              OMOCODIA_TABLE[valore_da_sostituire] +
              CF_calcolato.substring(
                posizione_caratteri_sostituibili[i] + 1,
                15
              );
          }

          //cod verifica
          let val = 0;
          for (let i = 0; i < 15; i++) {
            const c = CF_calcolato[i];
            val += i % 2 !== 0 ? CHECK_CODE_EVEN[c] : CHECK_CODE_ODD[c];
          }
          val = val % 26;
          let cod_verifica_calcolato = CHECK_CODE_CHARS.charAt(val);

          CF_calcolato += cod_verifica_calcolato;

          famigliaCF.push((fullCheck) ? CF_calcolato : CF_calcolato.substr(0, 6));
        }

        let CF_cogn = CF.substr(0, 3);
        let CF_nome = CF.substr(3, 3);

        let CF_giorno = parseInt(CF.substr(9, 2), 10);
        let CF_cod_mese = CF.substr(8, 1);
        let CF_cod_year = parseInt(CF.substr(6, 2), 10);

        let CF_cod_comune = CF.substr(11, 4);
        let CF_cod_verifica = CF.substr(15, 1);

        let sesso_ok = (sesso === 'M') ? CF_giorno < 40 : (sesso === 'F') ? CF_giorno > 40 : false;

        let m = "";
        if ((famigliaCF as any).includes((fullCheck) ? CF : CF.substr(0, 6)) && sesso_ok) return true; // indica validità
        if (cod_cogn_calcolato !== CF_cogn) m += " " + mCogn; //return mCogn;

        if (cod_nome_calcolato !== CF_nome) m += " " + mNome; //return mNome;
        if (parseInt(cod_giorno_calcolato) != CF_giorno) m += " " + mGior; //return mGior;
        if (cod_mese_calcolato != CF_cod_mese) m += " " + mMese; //return mMese;
        if (cod_anno_calcolato != CF_cod_year.toString()) m += " " + mAnno; //return mAnno;
        if (cod_luogo_nascita_calcolato !== CF_cod_comune) m += " " + mLuog; //return mLuog;
        if (m.length === 0) m += " " + mGene; //return mGene;

        //aggiunge messaggi di debug
        if (debug) {
          m += "DEBUG INFO: ";
          //mCogn += "";
          //mNome += "";
          m +=
            " data_nascita:[" +
            data_nascita +
            "] giorno calcolato:[" +
            cod_giorno_calcolato +
            "] giorno CF:[" +
            CF_giorno +
            "]  cf calcolato:[" +
            famigliaCF[0] +
            "]"; //mGior
          m +=
            " mese calcolato: [" +
            cod_mese_calcolato +
            "] mese CF: [" +
            CF_cod_mese +
            "]"; //mMese += "";
          m +=
            " anno calcolato: [" +
            cod_anno_calcolato +
            "] anno CF: [" +
            CF_cod_year +
            "]"; //mAnno += "";
          //mLuog += "";
          //mGene += "";
          //mData += "";
          //mDat1 += "";
          m += " famCF:[" + famigliaCF + "]";
        }

        return m;
      } catch (error) {
        return "ERRORE: " + error.toString();
      }
    }
  }
}
